{
  "common": {
    "show": "Afficher",
    "about": "À propos de",
    "newPost": "Nouvelle publication",
    "active": "Actif",
    "change": "Modification",
    "remove": "Supprimé",
    "cancel": "Annuler",
    "publish": "Publier",
    "save": "Sauvegarder",
    "draft": "Brouillon",
    "scheduled": "Programmées",
    "published": "Publié",
    "actions": "Actions",
    "archive": "Archiver",
    "delete": "Supprimer",
    "edit": "Modifier",
    "edited": "Modifié",
    "settings": "Paramètres",
    "signUp": "S'inscrire",
    "by": "Par",
    "for": "pour",
    "you": "Vous",
    "one": "un",
    "option": "Option ",
    "registered": "inscrit",
    "to": "à",
    "allEvents": "Tous les événements",
    "placeholder": "paramètre fictif",
    "percentOf": "% de",
    "private": "Privé",
    "updatedOn": "Mis à jour le",
    "blogPost": "Article de blog",
    "category": "Catégorie",
    "author": "Auteur",
    "status": "Statut",
    "errors": "Erreurs",
    "all": "Tout",
    "archived": " Archivé",
    "back": "Retour",
    "restore": "Restaurer cette version",
    "next": "Suivant",
    "previous": "Précédent",
    "continue": "Continuer",
    "continueButton": "Continuer",
    "paid": "Payé",
    "free": "Gratuit",
    "uploadImagesVideos": "Télécharger des images/vidéos",
    "upload": "Télécharger",
    "add": "Ajouter",
    "on": "Activé",
    "from": "de",
    "members": "membres",
    "visibility": "Visibilité",
    "public": "Public",
    "description": "Description",
    "managedBy": "Géré via",
    "noManagers": "Aucun gestionnaire",
    "noDescription": "Aucune description",
    "more": "Plus",
    "moreCaps": "Plus",
    "less": "moins",
    "and": "et",
    "in": "dans",
    "allSet": "Vous êtes prêt !",
    "createdBy": "Créé par",
    "home": "accueil",
    "selected": "Sélectionné",
    "groupMembers": "Membres du groupe",
    "everyone": "Tout le monde",
    "manager": "Gestionnaire",
    "leave": "Abandonner",
    "membersList": "Liste des membres",
    "findChannelManagers": "Rechercher des gestionnaires de canaux",
    "searchGroupMembers": "Rechercher les membres du groupe",
    "searchMembers": "Rechercher des membres",
    "searchMember": "Rechercher un membre",
    "enterDescription": "Saisissez une description",
    "apply": "Appliquer",
    "selectRole": "Sélectionnez un rôle",
    "people": "Personnes",
    "viewProfile": "Afficher le profil",
    "leaderboard": "Classement",
    "events": "Événements",
    "logOut": "Se déconnecter",
    "topLevelReached": "Niveau supérieur atteint",
    "topLevelReachedExclaim": "Niveau supérieur atteint !",
    "congratsTopLevel": "Félicitations ! Vous avez atteint le niveau supérieur !",
    "share": "partager",
    "copyLink": "copier le lien",
    "reply": "Réponse",
    "download": "Télécharger",
    "noPreviewAvailable": "Aucun aperçu disponible",
    "userNotFound": "Utilisateur non trouvé",
    "userNotFoundMessage": "Utilisateur non trouvé",
    "thisGroupIsPrivate": "Ce groupe est privé",
    "unableToPreviewPdf": "Actuellement, impossible de prévisualiser le fichier PDF. Veuillez le télécharger pour l'afficher.",
    "failedToDownloadPdf": "Impossible de télécharger le fichier PDF",
    "notifyAll": "Notifier tout le monde sur le canal",
    "communities": "Communautés",
    "courses": "Cours",
    "affiliates": "Affiliés",
    "chats": "Chat",
    "switchToDarkMode": "Passer en mode sombre",
    "switchToLightMode": "Passer en mode clair",
    "editProfile": "Modifier le profil",
    "account": "Compte",
    "logout": "Déconnexion",
    "noResults": "Aucun résultat",
    "confirmPayment": "Enregistrer le paiement",
    "done": "Terminé",
    "manage": "GÉRER",
    "copied": "copié",
    "submit": "Envoyer",
    "request": "Demande",
    "approve": "Approuver",
    "decline": "Refuser",
    "comingSoon": "À venir",
    "detailsUpdatedSuccessfully": "Informations mises à jour avec succès",
    "oopsUnableToSaveDetails": "Oups ! Impossible d'enregistrer les informations.",
    "verificationFailedPleaseTryAgain": "Échec de la vérification ! Veuillez réessayer",
    "loading": "Chargement",
    "title": "Titre",
    "addLink": "Ajouter un lien",
    "writeHere": "Écrivez ici",
    "copy": "Copier",
    "reset": "Réinitialiser",
    "register": "inscrire",
    "search": "Rechercher",
    "confirm": "Confirmer",
    "success": "Succès",
    "toReview": "à avis",
    "invite": "invitation",
    "contributions": "Conversions",
    "communitiesSettings": "paramètres de communauté",
    "create": "Créer",
    "name": "Nom",
    "linkCopied": "lien copié!",
    "move": "Déplacer",
    "irreversible": "irréversible",
    "close": "Fermer",
    "greeting": "Hier, {name}!",
    "managePayments": "gérer les paiements",
    "manageYourAccount": "gérer votre compte",
    "accountSettings": "paramètres du compte",
    "proceed": "Poursuivre",
    "uploading": "chargement",
    "retry": "Réessayer",
    "login": "se connecter",
    "follow": "Suivre",
    "following": "Suivis",
    "followers": "Abonnés",
    "view": "AFFICHER",
    "selectAnOption": "Sélectionner une option",
    "channels": "Canaux",
    "somethingWentWrong": "Une erreur s'est produite, veuillez réessayer",
    "switchToNormalMode": "Passez en mode normal",
    "switchToReadingMode": "Passer en mode lecture",
    "goToHomepage": "Accéder à la page d’accueil",
    "onlyGroupOwnersCanCreateCourses": "Seuls les propriétaires de groupe peuvent créer de nouveaux cours",
    "createGroup": "Créer un groupe",
    "discover": "Discover",
    "continuePayment": "Passer au paiement",
    "invalidCredentials": "Vous avez saisi une adresse e-mail ou un mot de passe arrivé à expiration. Veuillez réessayer.",
    "comingUpEvents": "Événements à venir !",
    "integratePaymentGateway": "Intégrer la passerelle de paiement",
    "connectPaymentGateway": "Connectez une nouvelle passerelle de paiement ou gérer vos passerelles existantes.",
    "isLive": "est en direct",
    "justNow": "À l'instant",
    "likes": "Mentions J'aime",
    "accessRequired": "Accès*",
    "zeroProgress": "0",
    "noFollowersTitle": "Il semble que personne ne vous suive.",
    "noFollowersSubtext": "Ajoutez votre relation à la liste de comptes suivis",
    "noFollowingTitle": "Vous ne suivez personne.",
    "noFollowingSubtext": "Commencez à suivre des personnes pour voir leurs publications",
    "followBack": "Suivre en retour",
    "logIn": "SE CONNECTER",
    "video": "Vidéo",
    "audio": "Audio",
    "newVersionAvailable": "Une nouvelle version de l'application est disponible. Veuillez mettre à jour pour utiliser cette fonctionnalité !",
    "ariaLabels": {
      "backButton": "Bouton Retour",
      "openEventLocation": "Ouvrir l'emplacement de l'événement",
      "editEvent": "Modifier l'événement",
      "deleteEvent": "Supprimer l'événement",
      "cancelRsvp": "Annuler la participation",
      "publicGroupRadio": "Bouton radio de groupe public",
      "privateGroupRadio": "Bouton radio de groupe privé",
      "accessibleFromSwitcherCheckbox": "Case à cocher Accessible depuis le bouton à bascule",
      "allowMembersToInviteCheckbox": "Case à cocher Autoriser les membres à inviter",
      "addMembers": "Ajouter des membres",
      "settings": "Paramètres",
      "leaveChannel": "Quitter le canal",
      "channelSettings": "Configuration du canal",
      "selectRole": "Sélectionner un rôle",
      "deleteChannel": "Supprimer le canal",
      "changeToPrivateChannel": "Modifier en canal privé",
      "allowMembersToPosts": "Autoriser les membres à publier",
      "restrictMembersFromPosts": "Empêcher les membres d'envoyer des publications",
      "close": "Fermer",
      "open": "Ouvrir",
      "more": "Plus",
      "upload": "Télécharger",
      "play": "Lire",
      "pause": "Mettre en pause",
      "mute": "Désactiver le son",
      "unmute": "Activer le son",
      "fullscreen": "Mode plein écran",
      "exitFullscreen": "Quitter le mode plein écran",
      "download": "Télécharger",
      "share": "Partager",
      "like": "Aimer",
      "comment": "Commenter",
      "reply": "Répondre",
      "pin": "Épingler",
      "unpin": "Détacher",
      "report": "Rapport",
      "copyLink": "Copier le lien",
      "embedCode": "Code d'intégration",
      "previewImage": "Image d'aperçu",
      "profileImage": "Image de profil",
      "coverImage": "Image de couverture",
      "thumbnail": "Vignette",
      "attachment": "Pièce jointe",
      "removeAttachment": "Supprimer la pièce jointe",
      "uploadFile": "Télécharger un fichier",
      "selectFile": "Sélectionner un fichier",
      "searchIcon": "Icône de recherche",
      "menuIcon": "Icône de menu",
      "notification": "Notification",
      "messages": "Messages",
      "profile": "Profil",
      "logout": "Déconnexion",
      "send": "Envoyer",
      "cancel": "Annuler",
      "submit": "Envoyer",
      "next": "Suivant",
      "previous": "Précédent",
      "refresh": "Actualiser",
      "filter": "Filtrer",
      "sort": "Trier",
      "view": "Afficher",
      "expand": "Développer",
      "collapse": "Réduire",
      "downloadFile": "Télécharger le fichier",
      "closeModal": "Fermer la fenêtre modale",
      "addMedia": "Ajouter des médias",
      "lightModeRadio": "Bouton radio du mode clair",
      "darkModeRadio": "Bouton radio du mode sombre",
      "communityThemeRadio": "Bouton radio de thème de communauté",
      "userProfile": "Profil Utilisateur",
      "postActions": "Actions de publication",
      "chatWindow": "Fenêtre de chat",
      "chatActions": "Actions de chat",
      "minimizeChat": "Réduire le chat",
      "closeChat": "Fermer le chat",
      "commentActions": "Actions de commentaire",
      "replyToComment": "Répondre au commentaire",
      "groupLogo": "Logo du groupe",
      "pinGroupIcon": "Icône Épingler le groupe",
      "appSwitcher": "Sélecteur d'applications",
      "communities": "Communautés",
      "courses": "Cours",
      "search": "Rechercher",
      "giphyLogo": "Logo Giphy",
      "backToConversations": "Retour aux Conversations",
      "commentAttachments": "Pièces jointes de commentaire",
      "tabSwitcher": "Sélecteur d'onglets",
      "eventCover": "Couverture d'événement",
      "eventCoverPreview": "Aperçu de la couverture d'événement",
      "selectPaidEvent": "Sélectionner un événement payant",
      "selectFreeEvent": "Sélectionnez un événement gratuit",
      "selectCurrency": "Sélectionner la devise",
      "logo": "Logo",
      "closeReviewMembershipAnswersModal": "Fermer la fenêtre modale Analyser les réponses d'adhésion",
      "liveStream": "Diffusion en direct",
      "openGroupMembers": "Ouvrir les membres du groupe",
      "communityBanner": "Bannière de la communauté",
      "home": "Accueil",
      "mentionItem": "Mentionner l'élément",
      "back": "Retour",
      "viewGroup": "Afficher le groupe",
      "invitationIcon": "Icône d'invitation",
      "openUserProfile": "Ouvrir le profil utilisateur",
      "closeStream": "Fermez le flux",
      "groupAvatar": "Avatar du groupe",
      "bannerImage": "Image de bannière",
      "avatarImage": "Image d'avatar",
      "userAvatar": "Avatar de l'utilisateur",
      "eventImage": "Image de l'événement",
      "postImage": "Image de la publication",
      "channelIcon": "Icône du canal",
      "groupIcon": "Icône du groupe",
      "communityIcon": "Icône de la communauté",
      "memberAvatar": "Avatar de membre",
      "creatorAvatar": "Avatar du créateur",
      "authorAvatar": "Avatar de l'éditeur",
      "aboutFeaturedPost": "À propos de la publication en vedette",
      "accountSettings": "Paramètres du compte",
      "addChannel": "Ajouter un canal",
      "addCourse": "Ajouter un cours",
      "addEmoji": "Ajouter un emoji",
      "affiliates": "Affiliés",
      "announceEvents": "Annoncer des événements",
      "avatar": "Avatar",
      "badge": "Badge",
      "camera": "Caméra",
      "cardImage": "Image de carte",
      "categoryName": "Nom de la catégorie",
      "channelList": "Liste des canaux",
      "channelSelect": "Sélectionner le canal",
      "chatAttachment": "Pièce jointe de chat",
      "chats": "Chats",
      "closeCourseDetails": "Fermer les informations du cours",
      "closeLoginModal": "Fermer la fenêtre de connexion",
      "closeMembershipQuestionsModal": "Fermer la fenêtre modale des questions d'adhésion",
      "closePaymentModal": "Fermer la fenêtre modale de paiement",
      "commentCard": "Carte de commentaire",
      "communityTheme": "Sujet de la communauté",
      "conversationItem": "Élément de conversation",
      "conversationSuggestion": "Suggestion de conversation",
      "createChannel": "Créer un canal",
      "customThemeRadio": "Bouton radio Thème personnalisé",
      "deleteAnswerButton": "Bouton Supprimer la réponse",
      "deleteFile": "Supprimer le fichier",
      "editLevelName": "Modifier le nom du niveau",
      "editProfile": "Modifier le profil",
      "enterEmailAddress": "Saisir l'adresse e-mail",
      "featuredIcon": "Icône mise en avant",
      "giveAdministrativePrivileges": "Accorder des privilèges administratifs",
      "gokollabLogo": "Logo Gokollab",
      "icon": "Icône",
      "image": "Image",
      "likeContent": "Aimer le contenu",
      "link": "Lien",
      "marketplaceGroupSlug": "Slug du groupe des applications de la marketplace",
      "microphone": "Microphone",
      "nextAttachment": "Pièce jointe suivante",
      "noEvents": "Aucun événement",
      "noCommunitiesIllustration": "Aucune illustration de communautés",
      "noCoursesFound": "Aucun cours trouvé",
      "noFollowers": "Aucun abonné",
      "noFollowing": "Aucun suivi",
      "noPostsFound": "Aucune publication trouvée",
      "notificationItem": "Élément de notification push",
      "notificationsList": "Liste des notifications",
      "openEmbeds": "Ouvrir les intégrations",
      "openEmbedsDrawer": "Tiroir Ouvrir les intégrations",
      "openEventColor": "Ouvrir la couleur de l'événement",
      "openEventDetails": "Ouvrir les détails de l'événement",
      "permissionNeeded": "Permission requise",
      "pointsAndLevels": "Points et niveaux",
      "previousAttachment": "Pièce jointe précédente",
      "reactedUser": "Utilisateur ayant réagi",
      "reward": "Récompense",
      "rewards": "Récompenses",
      "selectChannel": "Veuillez sélectionner un canal",
      "selectEventOption": "Sélectionnez une option d'événement",
      "selectIcon": "Sélectionner l'icône",
      "selectTimezone": "Sélectionner le fuseau horaire",
      "showChannelIcons": "Afficher les icônes des canaux",
      "sidebarActionButton": "Bouton d'action de la barre latérale",
      "speaker": "Haut-parleur",
      "text": "Texte",
      "thisGroupIsPrivate": "Ce groupe est privé",
      "toReview": "Pour évaluation",
      "toggleFeaturedPost": "Activer/désactiver la publication en vedette",
      "toggleRewardsOptions": "Basculer les options de récompenses",
      "viewReplies": "Afficher les répondre",
      "courseThumbnail": "course-thumbnail",
      "moreManagers": "autres gestionnaires",
      "arrowIcon": "→",
      "okHandEmoji": "👌",
      "closeIcon": "✕",
      "changeToPublicChannel": "Modifier en canal public",
      "showMandatoryInfoModal": "Afficher la case à cocher de la fenêtre modale de profil obligatoire"
    },
    "placeholders": {
      "groupName": "Nom du groupe",
      "groupSlug": "Slug du groupe",
      "url": "URL",
      "enterPrice": "Saisir un prix",
      "enterName": "Saisir le nom",
      "enterEmail": "Saisir l'adresse e-mail",
      "selectTimezone": "Sélectionner le fuseau horaire",
      "selectChannel": "Sélectionner un canal",
      "enterSkoolGroupUrl": "Saisissez l'URL de votre communauté Skool"
    },
    "email": "E-mail",
    "errorLoadingConversations": "Erreur lors du chargement des conversations",
    "noConversations": "Aucune conversation"
  },
  "imageUpload": {
    "cropYourAvatar": "Rognez votre avatar",
    "dragToReposition": "Faites glisser pour repositionner",
    "ariaLabels": {
      "imageUploader": "Téléchargeur d'images",
      "avatar": "Avatar",
      "clearFile": "Effacer le fichier",
      "removeAvatar": "Supprimer l'avatar de profil",
      "zoomButton": "Bouton Zoom"
    }
  },
  "mediaUpload": {
    "uploadVideo": "Télécharger une vidéo",
    "addVideoUsingLink": "Ajouter une vidéo via un lien",
    "uploadImage": "Télécharger une image",
    "addVideo": "Ajouter une vidéo"
  },
  "mandatedInfoModal": {
    "completeYourProfile": "Terminez votre profil",
    "profileIntentMessage1": "Les communautés se sentent bizarres sans visages ni noms.",
    "profileIntentMessage2": "Les profils instaurent la confiance et créent des liens avec les autres",
    "complete": "COMPLET",
    "recommendedAspectRatio": "télécharger un {types}. Pourcentage 1:1",
    "addBio": "Ajouter une biographie... (facultatif)"
  },
  "validations": {
    "nameRequired": "Le nom est obligatoire !",
    "invalidDescription": "Description non valide !"
  },
  "payment": {
    "recurringWithTrial": "Une somme de {price} {currencySymbol} vous sera facturée tous les {interval} après la période d'essai et vous pourrez annuler à tout moment.",
    "recurring": "{price} {currencySymbol} tous les {interval} avec la possibilité d'annuler à tout moment.",
    "oneTime": "{price} {currencySymbol} {paymentText}",
    "defaultOneTimeText": "prix unique pour l'abonnement.",
    "totalAmount": "Montant total",
    "trialDays": "Essai de {days} jours",
    "securePayments": "Paiements 100 % sécurisés",
    "allowToChargeCard": "En fournissant les informations de votre carte, vous autorisez {locationName} à débiter votre carte pour les paiements futurs conformément à ses conditions.",
    "paymentSuccessful": "Paiement réussi !"
  },
  "channel": {
    "notifications": {
      "managersEdited": "Les gestionnaires ont bien été modifiés !",
      "managersAdded": "Gestionnaires ajoutés avec succès !",
      "managersAddedToChannel": "managers ajoutés à",
      "membersAdded": "Les membres ont bien été ajoutés.",
      "memberPostingEnabled": {
        "title": "Erreur lors de la publication des membres",
        "content": "membres de la publication ont été"
      },
      "roleUpdated": "Rôle mis à jour avec succès !",
      "updatedRoleOf": "Rôle de {name} mis à jour",
      "userRemoved": "Utilisateur supprimé avec succès !",
      "removedUserFrom": "{name} retiré de {channelName}",
      "errorOccurred": "Une erreur s'est produite",
      "updated": {
        "title": "Paramètres du canal mis à jour",
        "contentPrivate": "Le canal {channelName} est maintenant privé",
        "contentPublic": "Le canal {channelName} est maintenant public",
        "content": ""
      },
      "deleted": {
        "title": "Le canal a été supprimée avec succès",
        "content": ""
      },
      "membersAddedSuccess": {
        "title": "Les membres ont bien été ajoutés.",
        "content": "{count} membres ont été ajoutés à {channelName}"
      },
      "managersAddedSuccess": {
        "title": "Gestionnaires ajoutés avec succès !",
        "content": "{count} gestionnaires ajoutés à {channelName}"
      },
      "memberPostingDisabled": {
        "title": "Erreur lors de la publication des membres",
        "content": "La publication des membres a été désactivé"
      },
      "visibilityChangedToPublic": "Le canal {channelName} est maintenant public",
      "visibilityChangedToPrivate": "Le canal {channelName} est maintenant privé",
      "created": {
        "title": "Création d'un nouveau canal",
        "content": ""
      },
      "error": {
        "createFailed": {
          "title": "Échec de la création du canal",
          "content": "Veuillez réessayer plus tard"
        },
        "updateFailed": {
          "title": "Échec de la mise à jour du canal",
          "content": "Veuillez réessayer plus tard"
        },
        "managersEditedFailed": {
          "title": "Échec de la mise à jour des gestionnaires !",
          "content": ""
        },
        "addFailed": {
          "title": "L'ajout de gestionnaires a échoué !",
          "content": ""
        },
        "addMembersFailed": {
          "title": "L'ajout des membres a échoué.",
          "content": ""
        }
      }
    },
    "createChannel": "Créer un canal",
    "updateChannel": "METTRE À NIVEAU le canal",
    "addMembers": "Ajouter des membres",
    "addManagers": "Ajouter des gestionnaires",
    "typeToAddMoreMembers": "Saisir pour inclure des membres",
    "examplePlaceholder": "ex. John ou Jane",
    "makeChannelManager": "Créer un gestionnaire de canal",
    "removeFromChannelManager": "Supprimer du gestionnaire de canal",
    "manager": "Gestionnaire",
    "channelManager": "Gestionnaire de canaux",
    "noMembersFound": "Aucun membre trouvé.",
    "noManagersFound": "Aucun gestionnaire trouvé.",
    "removeChannelMember": "Supprimer le membre du canal",
    "removeConfirmationMessage": "Voulez-vous vraiment supprimer ?",
    "makeManagerConfirmationMessage": "Voulez-vous vraiment que",
    "makeManagerConfirmationMessage2": "devienne gestionnaire de canal dans",
    "channelName": "Nom du canal",
    "channelIcon": "Icône du canal",
    "addChannel": "Ajouter un canal",
    "editChannel": "Modifier le canal",
    "announcementChannel": "canal d'avertissement",
    "noChannelsAvailable": "Aucun canal disponible",
    "makeChannelPrivate": "Rendre le canal privé",
    "makeChannelPrivateMessage": "Restreindre l'accès du membre à toutes les discussions et interactions du canal.",
    "readOnlyChannel": "canal en lire seule",
    "readOnlyChannelMessage": "Les membres peuvent afficher des informations et des mises à jour IMPORTANT",
    "createPrivateChannel": "Rendre ce canal privé",
    "createPrivateChannelMessage": "membres invités uniquement. Aucun membre ne verra cet espace",
    "allowMembersToPost": "Créer des membres à partager",
    "allowMembersToPostMessage": "Activez cette option .",
    "enableMemberPostingConfirmation": {
      "mainMessage": "Le fait d'activer la publication des membres sera",
      "mainMessage2": "Assurez-vous que chaque membre est informé des autorisations de publication.",
      "pointer1": "Cette Action peut être annulée à une Date donnée.",
      "pointer2": "chaque publication par membre sera visible par tout le monde in le canal."
    },
    "privateChannelTooltip": "Vous n'avez pas accès à ce canal",
    "restrictMembersFromPosting": "Empêcher les membres de publier",
    "restrictMembersFromPostingMessage": "La modification de cette option empêchera les membres de créer des publications et des feedback dans le canal.",
    "disableMemberPostingConfirmation": {
      "mainMessage": ".",
      "mainMessage2": "Assurez-vous que chaque membre est informé des restrictions de publication Nouveau.",
      "pointer1": "Cette Action peut être annulée à une Date donnée.",
      "pointer2": "Chaque de publication in le canal."
    },
    "deleteChannel": "Supprimer le canal",
    "deleteChannelMessage": "La suppression du canal entraîne la perte définitive de toutes les données qui y sont associées.",
    "deleteChannelMessageWithCourse": "La suppression du canal entraînera la perte totale des données des membres et de tout cours lié à ce canal deviendra public à moins que vous ne les tentiez de les supprimer.",
    "editChannelName": "Modifier le nom du canal",
    "editChannelDescription": "Modifier la description du canal",
    "channelNamePlaceholder": "par exemple : rapports de marketing",
    "editManagers": "Modifier les gestionnaires",
    "channelManagers": "Gestionnaires de canaux",
    "leaveChannel": "Abandonner le canal",
    "leaveChannelConfirmation": "Voulez-vous vraiment quitter ce canal ?",
    "changeToPrivateChannel": "Rendre le canal privé",
    "changeToPrivateChannelMessage": "Rendre le canal privé limitera l'utilisation du canal pour les interactions et les discussions à ses membres uniquement.",
    "changeToPrivateChannelConfirmation": {
      "mainMessage": "Passer à ce canal sera privé, il sera nécessaire de fournir le texte que vous souhaitez faire traduire.",
      "mainMessage2": "Assurez-vous d'inclure chaque membre souhaité à votre canal privé.",
      "pointer1": "Cette Action est",
      "pointer2": "Les nouveaux membres ajoutés au canal aura/auront accès à des conversations et des interactions au sein du canal."
    },
    "changeToPublicChannel": "Rendre le canal public",
    "changeToPublicChannelMessage": "Rendre le canal public permettra à tous les membres du groupe de voir et de participer à ce canal.",
    "changeToPublicChannelConfirmation": {
      "mainMessage": "Passer ce canal en mode public le rendra public à tout le monde de la communauté.",
      "mainMessage2": "Tout le monde dans le Groupe pourra afficher et rejoindre ce canal.",
      "pointer1": "Tout le monde de la communauté aura automatiquement se connecter à ce canal.",
      "pointer2": "Le contenu des canaux privés précédents deviendra visible pour tous les membres du groupe."
    },
    "publicChannel": "Canal public",
    "peopleWhoCanManage": "Des personnes capables de gérer",
    "addChannelHelperText": "en plus de Duet connexion.",
    "privateChannel": "Canal privé",
    "removeFromChannel": "Retirer du canal",
    "removeConfirmationMessage2": "de ce canal",
    "findChannelManagers": "Rechercher des gestionnaires de canaux",
    "removeChannelManager": "Effacer le gestionnaire de canaux",
    "irreversible": "Cette action est irréversible"
  },
  "chat": {
    "unblockUser": "Débloquer l'utilisateur",
    "blockUser": "Bloquer un utilisateur",
    "blockMessage1": "Vous ne pourrez plus envoyer de messages à cet utilisateur.",
    "blockMessage2": "Ce compte ne sera pas bloqué sur le groupe. Vous pourrez peut-être toujours voir leurs publications, feedback et réactions.",
    "deleteChat": "Supprimer le chat",
    "deleteChatMessage": "Voulez-vous vraiment supprimer cette conversation ?",
    "block": "Bloquer",
    "conversation": "conversation",
    "youPrefix": "Vous : ",
    "messageNotSent": "Ce message n'a pas été envoyé",
    "sending": "Envoi",
    "youAndUserKnowEachOther": "Vous et {name} vous connaissez",
    "startConversationWithHi": "Commencez une conversation en envoyant un « Bonjour »",
    "accountSettings": "Paramètres du compte",
    "blockedUserMessage": "Vous avez bloqué { name }, vous ne pouvez ni envoyer ni recevoir de messages. Débloquez-le pour démarrer une conversation. Pour consulter votre liste d'utilisateurs bloqués, visitez votre",
    "blockRecipientMessage": "{ name } vous a bloqué(e). Vous ne pouvez pas envoyer ni recevoir de messages.",
    "nothingFound": "Rien n'a été trouvé !",
    "pleaseCheckUsername": "Veuillez vérifier le nom d'utilisateur et réessayer",
    "startChatting": "Commencer à chatter",
    "noChatYet": "Il semblerait que vous n'ayez encore chatté avec personne.",
    "noChatYetMessage": "Recherchez un contact et faites le premier pas !",
    "noConversationsFound": "Aucune conversation n'a été trouvée",
    "searchMembersAndStartChatting": "Recherchez des membres et commencez à chatter",
    "cannotMessageDeletedUser": "Vous ne pouvez pas télécharger de messages vers un utilisateur",
    "message": "message",
    "media": "média",
    "files": "fichiers"
  },
  "comments": {
    "reportComment": "Signaler un commentaire",
    "reportCommentMessage": "Voulez-vous vraiment signaler ce commentaire ?",
    "deleteComment": "Supprimer le commentaire",
    "editComment": "Modifier le commentaire",
    "loadMoreReplies": "Charger plus de réponses",
    "deleteCommentMessage": "Voulez-vous vraiment supprimer ce commentaire ?",
    "writeComment": "Écrire un commentaire",
    "comment": "COMMENTAIRE",
    "cancel": "ANNULER",
    "save": "ENREGISTRER",
    "replyingTo": "En réponse à",
    "newComment": "Nouveau commentaire",
    "latest": "Dernier",
    "onlyAdminsCanComment": "Seuls les administrateurs de la communauté peuvent commenter in canal.",
    "isCommentDisabledForPost": "Le feedback est désactivé pour cette publication.",
    "isCommentDisabledErrorContent": "Les feedback ont été désactivé activé cette partager via l'éditeur ou l'admin du Groupe.",
    "isCommentDisabledErrorTitle": "Feedback désactivé"
  },
  "embeds": {
    "uploadImage": "Télécharger l’image",
    "addYoutubeVimeoLoomLink": "Ajoutez un lien Youtube, Vimeo ou Loom",
    "uploadAttachment": "Télécharger des fichiers PDF, CSV ou XLSX",
    "addAttachment": "Ajouter une pièce jointe",
    "allowedTypes": "SVG, PNG, JPG ou GIF (max. 800 x 400 px)",
    "placeholder": "Ajoutez un lien Youtube, Vimeo ou Loom",
    "uploadVideo": "Télécharger/Lier une vidéo",
    "uploadVideoPlaceholder": "Ajoutez un lien Youtube, Vimeo ou Loom",
    "uploadVideoAllowedTypes": "Téléchargez un fichier vidéo MP4",
    "addEmoji": "Ajouter des emoji",
    "emojiSuggestion": "Ouvre le sélecteur d’emoji",
    "addGif": "Ajouter un GIF",
    "gifSuggestion": "Open le sélecteur de GIF",
    "addImage": "Ajouter une image",
    "imageSuggestion": "Ouvre votre galerie",
    "addVideo": "Ajouter une vidéo",
    "videoSuggestion": "Ouvre votre galerie",
    "selectFile": "Sélectionner un fichier",
    "attachmentSuggestion": "Ouvre le gestionnaire de fichiers",
    "takePhoto": "Prendre une photo",
    "uploadPhotoVideo": "Télécharger une photo/vidéo",
    "limitExceeded": "Limite dépassée",
    "limitExceededMessage": "Vous ne pouvez pas joindre plus de 4 fichiers",
    "errorWhileUploadingFile": "Erreur lors du téléchargement du fichier ! Veuillez réessayer",
    "clickToUpload": "Cliquez pour télécharger",
    "orDragAndDrop": "ou glissez-déposez",
    "validUrl": "Une URL valide est requise",
    "enterSomeText": "Entrez du texte",
    "addLink": "Ajouter un lien",
    "text": "Texte",
    "addVideoLink": "Oups, il semble vous n'avez pas fourni YouTube Vimeo Wistia de texte à traduire. Pourriez-vous vous plaît fournir le texte vous souhaitez faire traduire en français ?",
    "uploadVideoAndImages": "télécharger des vidéos et des images",
    "recommendedAspectRatio": "{ratio}",
    "addHashtag": "Intitulé les canaux, événements et cours",
    "hashtagSuggestion": "Suggestion de hashtag"
  },
  "tabSwitcher": {
    "discussion": "Discussion",
    "learning": "Apprentissage",
    "members": "Membres",
    "people": "Personnes",
    "leaderboard": "Classement",
    "channels": "Canaux",
    "groups": "Groupes",
    "more": "Plus",
    "home": "accueil",
    "discover": "Découvrir",
    "courses": "Cours",
    "communities": "Communautés"
  },
  "groupInfo": {
    "pinGroup": "Groupe de brouillon",
    "unpinGroup": "désélectionner le Groupe",
    "maxPinnedGroupsLimit": "Seul au maximum 4 groupes peut être épinglé",
    "publicGroup": "Groupe public",
    "privateGroup": "Groupe privé",
    "coverImage": "Couverture du groupe",
    "members": "Membres",
    "posts": "Publications",
    "admin": "Admin",
    "settings": "PARAMÈTRES",
    "inviteMembers": "INVITER DES MEMBRES",
    "answerQuestions": "Répondre aux questions",
    "toJoin": "pour rejoindre {name}",
    "changeRole": "Modifier le rôle",
    "removeFromGroup": "Supprimer du groupe",
    "contributor": "Contributeur",
    "membershipAnswers": "Réponses d'adhésion",
    "unbanMember": "Membre réadmis",
    "banFromGroup": "Bannir du groupe",
    "requestedOn": "Demandé le",
    "invitedOn": "Invité le",
    "joinedOn": "Membre",
    "noMembersFound": "Aucun membre trouvé.",
    "youAreAllCaughtUp": "Vous êtes pris en compte",
    "banUserConfirmation": "Voulez-vous vraiment bannir cet utilisateur du groupe ?",
    "deleteContentCheckbox": "Supprimer le contenu de chaque personne",
    "active": "Actif",
    "admins": "Admins",
    "contributors": "Contributeurs",
    "requested": "Demandé",
    "banned": "Banni",
    "invited": "Invité",
    "paymentReceived": "Paiement reçu",
    "paymentInitiated": "Paiement lancé",
    "answeredQuestions": "Questions répondues",
    "answeredQuestionsMessage": "répondu à la question suivante pour rejoindre",
    "darkMode": "mode Sombre",
    "darkModeMessage": "Modifier l'apparence de la communauté pour réduire l'éblouissement et donner un répit à vos yeux.",
    "accessGranted": "Accès accordé : commencez votre aventure d'apprentissage.",
    "stepIntoAction": "Passez à l'action ! Collaborons et amusons-nous un peu.",
    "viewMembersAndMemberDetails": "Afficher les membres et les informations sur les membres",
    "reviewContentReportsAndMore": "Consulter les rapports sur le contenu et plus encore",
    "toReview": "Pour évaluer",
    "switchToOtherGroups": "Passer à un autre groupe",
    "placeholders": {
      "yourAnswer": "Votre réponse"
    },
    "notifications": {
      "userBanned": "L'utilisateur a été banni du groupe avec succès",
      "somethingWentWrong": "Une erreur s'est produite. Veuillez réessayer plus tard."
    },
    "membershipSettings": "Configuration de l’abonnement",
    "paymentFailed": "Le paiement a échoué !",
    "paymentFailedMessage": "Paiement échoué, votre demande pour rejoindre le groupe a été refusée.",
    "gamification": {
      "addRewards": "Ajouter des récompenses",
      "title": "Titre",
      "description": "Ajouter une description",
      "textbox": "Zone de texte",
      "singleSelect": "Sélection unique",
      "multipleSelect": "Sélection multiple",
      "question": "Question",
      "validations": {
        "titleRequired": "Veuillez indiquer un titre",
        "descriptionRequired": "Veuillez fournir une description",
        "somethingWentWrong": "Une erreur s'est produite. Veuillez réessayer plus tard.",
        "updatedRewards": "Récompenses mises à jour"
      },
      "settings": {
        "updatedRewards": "Récompenses mises à jour"
      }
    },
    "customCode": {
      "advanced": "Avancé",
      "testPreview": "Aperçu du test",
      "enableConfirmationMessage": "Ne l'activez qu'une fois que vous aurez vérifié l'aperçu du test",
      "testPreviewMessage": "Un nouvel onglet s'ouvrira avec l'aperçu du test de votre communauté. Vous pouvez l'utiliser pour vérifier si votre code personnalisé fonctionne comme prévu.",
      "liveMode": "Mode En direct",
      "customJS": "JS Personnalisée",
      "customCSS": "CSS Personnalisée",
      "trackingCode": "code de suivi",
      "headerCode": "code en-tête",
      "footerCode": "code du pied de page"
    },
    "branding": {
      "brandYourGroup": "Vous pouvez donner une marque de votre choix à votre groupe",
      "updateBranding": "Mettre à jour l’image de marque",
      "clickToUploadFavicon": "Cliquer pour télécharger Favicon",
      "dragAndDropFavicon": "Glisser et déposer : {types} (format 1:1)",
      "clickToUploadCover": "Cliquez pour télécharger le masquage",
      "dragAndDropCover": "Glisser et déposer : : {types} (format 16:9)",
      "clickToUploadLogo": "Cliquez pour télécharger le logo du groupe",
      "dragAndDropLogo": "Glisser et déposer : {types} (format 1:1)",
      "aspectRatioMustBe1To1": "Le rapport hauteur/largeur de la photo doit être de 1:1",
      "aspectRatioMustBe16To9": "Le rapport hauteur/largeur de la photo doit être de 16:9",
      "favicon": "favicône",
      "coverImage": "image de couverture",
      "logo": "logo",
      "invalidFileFormat": "Oups ! Format/type de document invalide.",
      "pleaseUploadImageType": "Types de fichiers pris en charge : {types}"
    },
    "groupAppearance": {
      "description": "Vous pouvez configurer votre groupe selon votre choix ici",
      "slug": "Mettre à jour votre groupe ici",
      "colorMode": "Mode couleur",
      "previewTheLook": "prévisualisez comment votre groupe sera in mode clair et sombre",
      "light": "clair",
      "dark": "sombre",
      "communityTheme": "thème de communauté",
      "customTheme": "thème Personnalisée",
      "windowGradient": "dégradé de la fenêtre",
      "applyGradientColorsToYourSidebarAndTopbar": "Appliquer des couleurs de dégradé à votre barre latérale et à votre barre supérieure",
      "labels": {
        "sidebarBackground": "arrière-plan de la barre latérale",
        "primary": "PRINCIPAL",
        "secondary": "secondaire",
        "tertiary": "tiers",
        "surface": "zone",
        "fontPrimary": "police",
        "fontSecondary": "police secondaire",
        "fill": "couleur de remplir",
        "border": "bordure",
        "error": "erreur",
        "background": "arrière-plan",
        "option": "Option"
      },
      "customThemes": {
        "default": "Par défaut",
        "zestyCitrus": "zz",
        "royalVelvet": "page de titre",
        "sunnyDelight": "entonnoir",
        "lushMeadow": "abonnement",
        "azureDreams": "couleur d'opacité",
        "bubblegumBliss": "opacité des rebonds",
        "ivoryWhisper": "chuchoté d'inventaire",
        "midnightDeep": "minuit"
      },
      "unsavedChanges": "dynamique non enregistrée",
      "unsavedChangesMessage": "Vous avez un champ dynamique non enregistré, voulez-vous vraiment annuler la dynamique ?"
    },
    "promotionalLinks": {
      "promotionalLinks": "Liens promotionnels",
      "createPromotionalLinkDescription": "Créez des liens promotionnels pour votre groupe",
      "addPromotionalLink": "Ajouter un lien",
      "deleteLink": "Supprimer le lien",
      "deleteLinkConfirmation": "Voulez-vous vraiment supprimer ce lien ?",
      "labels": {
        "description": "Description",
        "url": "URL",
        "private": "Privé",
        "privateLinksDescription": "Les liens privés ne sont visibles que par les membres du groupe"
      },
      "placeholders": {
        "enterLinkDescription": "Saisissez la description du lien",
        "enterLinkURL": "Entrez l'URL du lien"
      },
      "addPromotionalLinkDescription": "Créer des liens multiples pour votre groupe",
      "ariaLabels": {
        "editLink": "Modifier le lien",
        "deleteLink": "Supprimer le lien"
      }
    },
    "membershipQuestions": {
      "addQuestion": "Ajouter une question",
      "editQuestion": "Modifier la question",
      "editLevelName": "Modifier le nom du niveau",
      "addOption": "Ajouter une option",
      "level": "Niveau",
      "name": "Nom",
      "addMembersQuestionsDescription": "Ajouter des questions à poser aux membres quand ils demandent l'accès à votre groupe",
      "enableMembershipQuestions": "Activer les questions relatives à l'adhésion",
      "membershipQuestions": "Questions relatives à l'adhésion",
      "deleteQuestion": "Supprimer la question",
      "deleteQuestionConfirmation": "Voulez-vous vraiment supprimer cette question ?",
      "labels": {
        "textBox": "Zone de texte",
        "singleSelect": "Sélection unique",
        "multipleSelect": "Sélection multiple",
        "enableMembershipQuestions": "ajouter au moins une question pour activer les questions d'adhésion"
      },
      "validations": {
        "questionRequired": "Veuillez saisir la question",
        "answerOptionsRequired": "Un minimum de deux options est obligatoire, et elles doivent être uniques",
        "somethingWentWrong": "Une erreur s'est produite. Veuillez réessayer plus tard.",
        "updatedQuestions": "Questions mises à jour sur l'adhésion au groupe",
        "levelNameRequired": "Veuillez saisir le nom du niveau",
        "updatedLevelName": "Nom du niveau mis à jour"
      },
      "placeholders": {
        "enterLevelName": "Nom du niveau",
        "selectOne": "Sélectionnez-en un",
        "keepItShort": "soyez bref...",
        "exampleOffer": "e-mail 10 %."
      },
      "privacyNotice": "Je comprends que ma réponse sera archiver et visible par les administrateurs du groupe.",
      "ariaLabels": {
        "editQuestion": "Modifier la question",
        "deleteQuestion": "Supprimer la question"
      }
    },
    "gamificationAndRewards": {
      "title": "Personnaliser les niveaux et les récompenses",
      "description": "Personnalisez les noms de niveau et ajoutez des récompenses pour un meilleur engagement des membres",
      "gamification": "Ludification",
      "rewards": "Récompenses",
      "addRewards": "Ajouter une récompense",
      "ariaLabels": {
        "toggleGamification": "Activer/désactiver les options de ludification"
      }
    },
    "invitations": {
      "invitationSentSuccessfully": "Invitation envoyée avec succès",
      "invitationSentSuccessfullyDescription": "Invitation envoyée à {email}",
      "shareGroupLink": "Partagez le lien de votre groupe",
      "inviteMember": "Inviter un membre",
      "inviteMemberDescription": "Construisez votre communauté en invitant un nouveau membre",
      "inviteViaEmail": "Invitation via e-mail",
      "invitedMembersWillBeAutoApproved": "Les membres invités seront automatiquement acceptés pour rejoindre le groupe",
      "sendInvite": "ENVOYER UNE INVITATION",
      "permissionDenied": "Vous n'avez pas permission d'invitations à des membres. Veuillez Contact votre administrateur.",
      "labels": {
        "giveAdministrativePrivileges": "Accorder des privilèges administratifs",
        "giveAdministrativePrivilegesDescription": "Permettre à ce membre d'effectuer toutes les activités administratives",
        "name": "Nom",
        "email": "des E-mail",
        "nameLabel": "Nom",
        "emailLabel": "Adresse e-mail"
      },
      "placeholders": {
        "enterName": "Entrer le nom",
        "enterEmail": "Entrer l'adresse e-mail"
      }
    },
    "groupDetails": {
      "updateGroupDetails": "Mettre à jour les informations sur le groupe",
      "updateGroupDetailsDescription": "Mettez à jour les informations sur votre groupe ici",
      "slugNotAvailable": "Slug du groupe non disponible",
      "description": "Précisez la nature des discussions qui auront lieu au sein du groupe",
      "publicDescription": "Tout le monde peut voir les publications et les autres membres du groupe",
      "privateDescription": "Seuls les membres peuvent voir les publications et les autres membres du groupe",
      "accessibleFromSwitcher": "Accessible depuis le bouton à bascule",
      "accessibleFromSwitcherDescription": "Votre groupe sera visible pour les personnes qui ne sont pas membres du groupe dans le bouton à bascule.",
      "allowMembersToInvite": "Créer des membres pour invitations à de nouveaux membres",
      "allowMembersToInviteDescription": "masquer le bouton d'invitation pour les membres de l'aide. Les membres ne peuvent invitations à aucun autre si cela est activé.",
      "showMandatoryInfoModal": "Afficher la fenêtre modale de profil obligatoire",
      "showMandatoryInfoModalDescription": "Lorsque cette option est activée, les membres sont invités à remplir les informations de leur profil lorsqu'ils rejoignent le groupe.",
      "slug": "Slug du groupe",
      "discovery": {
        "title": "Découverte",
        "description": "Faites que des millions d'utilisateurs actifs vous trouvent. Le groupe sera visible sur la page de découverte dès que vous aurez plus de 10 membres.",
        "discoverChannels": "découvrir les canaux",
        "joinGroupToExploreAllChannels": "Renforcez le groupe pour découvrir chaque canal",
        "categoryIsUsedOnlyOnGokollab": "La catégorie est uniquement utilisée sur Gokollab",
        "categoryAutomaticallySuggested": "La catégorie est automatiquement suggérée par l'IA en fonction du titre et de la description de votre groupe. Pour une suggestion plus précise, assurez-vous que les informations que vous avez fournies à propos de votre groupe reflètent clairement son but et ses thèmes.",
        "categoryRefreshLimited": "La mise à jour des catégories est limitée à une fois toutes les 24 heures."
      },
      "placeholders": {
        "description": "Saisissez une brève description"
      },
      "validations": {
        "nameRequired": "Veuillez saisir un nom de groupe valide !",
        "slugRequired": "Veuillez saisir un slug de groupe valide !",
        "specialCharacterNotSupported": "Les caractères spéciaux ne sont pas pris en charge",
        "descriptionRequired": "Description du groupe obligatoire !",
        "emailRequired": "Veuillez saisir une adresse e-mail valide !",
        "fullNameRequired": "Veuillez saisir un nom valide !"
      },
      "labels": {
        "groupName": "Nom du Groupe"
      }
    },
    "subscriptions": {
      "manageSubscriptions": "Gérer votre abonnement",
      "viewAndManageGroupSubscriptions": "Afficher et gérer l'abonnement au groupe",
      "paymentIntegrationMissingMessage": "Veuillez intégrer les paiements in l'emplacement pour payer le groupe",
      "price": "prix",
      "currency": "devise",
      "priceDisplay": "{symbol}{price}{suffix}",
      "priceInterval": "/{interval}",
      "oneTime": " Une Date",
      "priceDeletedAlert": "Le produit de paiement est de synchronisation, cliquez ici pour resynchroniser",
      "intervals": {
        "month": "Mois",
        "year": "année",
        "week": "Semaine",
        "day": "Jour"
      },
      "addNewPrice": "prix",
      "editPrice": "Modifier le prix",
      "addPrice": "ajouter un prix",
      "subscriptionType": {
        "recurring": "récurrent",
        "oneTime": "Une Date"
      },
      "billingPeriod": {
        "monthly": "Mensuellement",
        "annually": "Annuellement",
        "weekly": "Hebdomadaire",
        "daily": "Quotidiennement"
      },
      "ariaLabels": {
        "freeMembership": "Bouton radio d'abonnement gratuit",
        "paidMembership": "Bouton radio d'abonnement payant"
      }
    },
    "menuOptions": {
      "details": "informations",
      "subscriptions": "abonnement",
      "branding": "image de marque",
      "themes": "thème",
      "tabsConfiguration": "Afficher / Masquer les onglets",
      "membershipQuestions": "questions adhésion",
      "gamificationAndRewards": "ludification et prix",
      "links": "Liens",
      "newsletter": "newsletter",
      "reportedContent": "contenu signalé",
      "discovery": "découvrir",
      "import": "importer"
    },
    "newsletter": {
      "title": "newsletter",
      "subheading": "Votre récapitulatif de communauté",
      "frequency": "Fréquence de la Newsletter",
      "description": "Un résumé des publications populaires, de l'activité des membres et des événements de ce groupe",
      "selectFrequency": "Sélectionnez une fréquence",
      "frequencies": {
        "off": "Désactivé",
        "daily": "Chaque jour",
        "weekly": "Chaque semaine",
        "biweekly": "Bimensuel",
        "monthly": "Chaque mois"
      }
    },
    "tabConfiguration": {
      "title": "Afficher / Masquer les onglets",
      "description": "Contrôlez les onglets qui apparaissent dans votre communauté. Activez ou désactivez chaque onglet pour créer une expérience ciblée et simplifiée pour vos membres.",
      "discussionDescription": "Lancez ou rejoignez des conversations pour partager des mises à jour, des idées et des perspectives avec votre communauté.",
      "learningDescription": "Créez et gérez des cours qui aident les membres à acquérir de nouvelles compétences ou connaissances.",
      "eventsDescription": "Planifiez, organisez et visualisez les sessions, ateliers ou événements communautaires à venir.",
      "leaderboardDescription": "Reconnaissez les membres les plus performants et encouragez un engagement sain grâce aux classements.",
      "membersDescription": "Gérez tous les membres et rôles. Cet onglet restera visible pour les administrateurs même lorsqu'il est désactivé, afin que la gestion des membres soit toujours accessible.",
      "aboutDescription": "Présentez l'objectif, les valeurs et l'historique de votre communauté pour aider les membres à se connecter.",
      "discussionTooltip": "La discussion est un onglet communautaire essentiel et ne peut pas être désactivée",
      "aboutTooltip": "L'onglet À propos est indispensable pour fournir des informations essentielles sur la communauté et ne peut pas être désactivé."
    },
    "groupSettings": {
      "groupSettings": "paramètres du Groupe",
      "changeGroupType": "modifier le saisir de Groupe",
      "changeGroupTypeDescriptionPrivateToPublic": "Le groupe dynamique à un groupe public signifie que chaque personne en attente sera refusé automatiquement, et le contenu deviendra visible. poursuivre?",
      "changeGroupTypeDescriptionPublicToPrivate": "dynamique à un groupe privé. poursuivre?",
      "changeGroupTypeConfirmation": "Voulez-vous vraiment modifier le groupe ?",
      "changeGroupTheme": "modifier le thème du Groupe",
      "changeGroupThemeDescription": "Cela modifiera le thème pour chaque membre du groupe. Voulez-vous vraiment modifier le thème du groupe ?",
      "updatedGroupDetails": "informations sur le Groupe mis à jour",
      "unableToSaveDetails": "Oups ! Impossible d' archiver les informations.",
      "groupNameIsRequired": "Le Nom du Groupe est obligatoire",
      "groupDescriptionIsRequired": "La Description du Groupe est obligatoire",
      "groupSlugIsRequired": "Le slug du Groupe est obligatoire",
      "groupSlugMustContainOnly": "Le slug du groupe doit contenir uniquement des lettres, des quantités et des abonnements",
      "groupSlugAlreadyExists": "Le slug du Groupe existe déjà. Veuillez utiliser un autre slug, car il est déjà pris",
      "groupSlugRestricted": "Ce slug correspond à l'un de nos mots-clés privés pour les liens de la communauté. Veuillez utiliser un autre slug.",
      "pleaseTryAgainLater": "Veuillez réessayer plus tard",
      "unsavedChangesMessage": "Vous avez slug de groupe non enregistré, voulez-vous vraiment les annuler ?"
    },
    "import": {
      "header": "importer des membres de Groupe Sack et leur contenu",
      "credentialDescription": "Entrez votre certificat total pour importer les membres de votre groupe et leur contenu",
      "csvUploadDescription": ".csv fichier dans les contacts de l'importation",
      "loginFailed": "Vous avez saisi un adresse e-mail non valide ou password. Veuillez réessayer.",
      "proceedWithImport": "poursuivre l' importer?",
      "iAgree": "J'accepte",
      "importTerms": "en cliquant sur « J'accepte », vous confirmez et reconnaissez que vous nous avez engagés en tant que contrat indépendant pour fournir services en votre nom (« services »). Les services incluent le transfert de certaines données, informations, contenus, propriétés intellectuelles ou tout autre contenu (« informations ») d'un compte de plateforme insuffisant. vous avez des autorisations de fournir l'autorisation de fournir les services de in plateforme, et (3) le transfert d'informations ne sera pas affecté par les autorisations intellectuelles d'un tiers. Vous acceptez de nous indemniser, de nous défendre et de nous dégager de toute responsabilité en cas de réclamation de tiers résultant de votre violation des répétitions et des garanties ci-dessus.",
      "pleaseDownloadCSV": "Veuillez télécharger le fichier . CSV",
      "step01": "Étape 01 à",
      "step02": "Étape 02 à",
      "uploadCSV": "télécharger votre . CSV",
      "step01Description": "Formulaire in Messager Interactif pour les membres du groupe tels que Gmail, prénom, etc. Assurez-vous que le CSV est téléchargé in",
      "thisTemplate": "ce modèle",
      "importCSV": "importer .ASCV",
      "reSyncData": "Resynchronisez vos données avant de les télécharger.",
      "refreshUserList": "actualiser la liste des utilisateurs",
      "reSyncDataDescription": "Si vous souhaitez in votre liste et télécharger le CSV.",
      "pleaseDontChangeProfileSlug": "Veuillez ne pas modifier le slug du profil.",
      "selectFile": "Sélectionner un fichier",
      "changeFile": "modifier le fichier",
      "importMembersFailedText": "Cela peut être dû au fait que l'adresse e-mail est manquante. Veuillez cookies. Veuillez fournir le texte que vous souhaitez traduire.",
      "upload": "télécharger",
      "tryAgain": "réessayer",
      "syncAllPosts": "Synchronisation de votre partage et de votre commentaire",
      "membersCouldNotBeAdded": "membres n'ont pas pu être ajoutés au groupe.",
      "importMembersSuccess": "Nous avons envoyé un e-mail à chaque personne des membres du groupe, confirmant leur adhésion in groupe et leur fournissant des informations d'accès. Cela aide à vous assurer que chaque membre est informé et peut accéder au groupe efficacement.",
      "importMembersAdded": "membres ont été ajoutés avec succès au groupe",
      "postsNotSynced": "Les publications restantes n'ont pas pu être synchronisées avec le groupe. Cela peut être dû au fait que les auteurs de partage n'ont pas été importés avec succès.",
      "migrationFailed": "La migration a échoué. Veuillez réessayer.",
      "migrationCompleted": "Terminaison de la migration !",
      "migrationInProgress": "Migration en cours",
      "createProfile": "Créer un profil",
      "enterCredentials": "Saisir les identifiants",
      "uploadingInProgress": "Téléchargez in cours !",
      "listMembers": "liste de membres",
      "downloaded": "télécharger",
      "uploaded": "téléchargé",
      "listPostsDownloaded": "liste de publications est télécharger.",
      "listPostsDownloading": "liste de publications est en cours de téléchargement.",
      "posts": "publications",
      "members": "membres",
      "imported": "importé",
      "step1": "Étape 1",
      "step2": "Étape 2",
      "step1Description": "Créez un profil membre in le groupe Sack.",
      "step1Description2": "(y compris le Nom, Id d'e-mail et le mot de passe)",
      "step2Description": "Entrez le certificat du membre de l'équipe",
      "skoolUrlPlaceholder": "Saisissez l'URL de votre communauté Skool",
      "emailPlaceholder": "Entrez Idd'e-mail de votre équipe",
      "emailTooltip": "Entrez les adresses e-mail des membres de votre compte Sly",
      "passwordPlaceholder": "Entrez le mot de passe de votre site web",
      "confirm": "Confirmer",
      "validation": {
        "skoolUrl": "Veuillez saisir une URL Sack valide",
        "email": "Une E-mail est obligatoire",
        "password": "Le mot de passe est obligatoire"
      }
    },
    "approved": "Approuvé",
    "pending": "En attente",
    "rejected": "Rejeté"
  },
  "invitations": {
    "intent": "Aidez cette communauté à grandir !",
    "cancelInvitation": "Annuler l'invitation",
    "inviteMembers": "Invitez les membres à collaborer dans cette communauté.",
    "inviteLink": "Lien vers l'invitation",
    "invitationLink": "lien d'invitation",
    "buildYourCommunity": "Construisez votre communauté !",
    "inviteMembersToCollaborate": "Vous avez créé une nouvelle communauté ! Invitez des membres à collaborer pour la faire vivre.",
    "invite": "Inviter",
    "basicInformation": "Informations de base",
    "permissions": "Autorisations"
  },
  "createPost": {
    "title": "Créer un nouvel article de blog",
    "placeholder": "À quoi pensez-vous ?",
    "liveStream": "Diffusion en direct",
    "slug": "Slug d'URL de l'article de blog",
    "titleHelp": "Le titre, la description et l'image seront utilisés pour la balise méta SEO",
    "nameLabel": "Titre de l'article de blog",
    "nameValidation": "Le titre est obligatoire",
    "descriptionLabel": "Description de la publication",
    "descriptionHelp": "Ajoutez une courte description pour que les internautes puissent avoir un aperçu de la publication. Préférez une longueur de 100 à 250 caractères",
    "descriptionValidation": "La description est obligatoire",
    "createLabel": "Créer une publication",
    "image": "Photo de l'article de blog",
    "imageDescription": "La taille recommandée est de 600 px * 400 px",
    "notificationTitle": "Article de blog créé",
    "notificationErrorTitle": "Impossible de créer l'article de blog",
    "postingIn": "Publication in",
    "editingIn": "Modifier in"
  },
  "post": {
    "downloadRecording": "Téléchargez l’enregistrement",
    "deletePost": "Supprimer la publication",
    "reportPost": "Signaler une publication",
    "editPost": "Modifier la publication",
    "createPost": "Créer une publication",
    "publish": "Publication",
    "publishPost": "Publier une publication",
    "addChannel": "Ajouter un canal",
    "selectChannel": "Veuillez sélectionner un canal",
    "addLink": "Ajouter un lien",
    "removeLink": "Supprimer le lien",
    "update": "Mise à jour",
    "unsavedChanges": "Vous avez des modifications non enregistrées",
    "unsavedChangesMessage": "Vos modifications non enregistrées seront perdues. Voulez-vous quand même continuer ?",
    "unpinFromChannel": "Détacher",
    "unpinFromHome": "Détacher",
    "deletePostConfirmation": "Voulez-vous vraiment supprimer cette publication ?",
    "reportPostConfirmation": "Voulez-vous vraiment signaler cette publication ?",
    "postNotFound": "Publication non trouvée",
    "postNotFoundMessage": "La publication que vous essayez d'afficher a été supprimée ou n'existe pas.",
    "loadMoreComments": "Charger plus de feedback",
    "channelNotFound": "Canal non trouvé",
    "isCurrentlyLive": "est maintenant en direct",
    "isStartingNow": "commence maintenant",
    "isHappeningInMinutes": "a lieu dans {minutes} minutes",
    "isHappeningInHours": "se passe in {hours} heure | se produisent in l'heure de {hours}",
    "publicChannel": "Canal public",
    "privateChannel": "Canal privé",
    "featured": "En vedette",
    "featuredAbout": "À propos de En vedette",
    "noPostsFound": "Aucune publication n'a été trouvée",
    "pinInfo": "Vous pouvez épingler des éléments à afficher en haut du groupe, notamment des publications, des règles et des hashtags.",
    "pinInfoEveryone": "Tout le monde dans le groupe verra ces éléments.",
    "pinInfoRemainVisible": "Les éléments épinglés restent visibles jusqu’à ce que vous les détachiez.",
    "pinInfoNewestItem": "Au fur et à mesure que vous épinglez des éléments, le plus récent apparaît en tête de liste.",
    "onlyVisibleToAdmins": "Visible uniquement par les administrateurs",
    "featuredAboutDescription": "Vos administrateurs ont épinglé ces éléments pour que le groupe puisse les voir.",
    "channelNotFoundMessage": "Vous n'êtes plus membre du canal auquel vous essayez d'accéder ou le canal a été supprimé.",
    "notifications": {
      "unpinned": "Détaché !",
      "pinned": "épinglé !",
      "reported": "La publication a été signalée !",
      "error": "Une erreur s'est produite !",
      "isCommentDisabled": "Feedback désactivé !",
      "isCommentEnabled": "Feedback activé !"
    },
    "movePostToChannel": "déplacer vers le canal",
    "pin": "code PIN",
    "pinToHome": "Attacher à accueil",
    "pinToChannel": "Attacher au canal",
    "whatIsYourTitle": "Quel est votre titre ?",
    "postMovedToChannel": "Partager déplacé vers le canal {channelName}",
    "upcomingEvent": "Événement à venir",
    "turnOffCommenting": "Désactivez les commentaires",
    "enableComments": "Enregistrer feedback",
    "disableComments": "Désactiver les commentaires",
    "moveToPrivateChannelConfirmation": {
      "title": "Déplacer vers le canal privé",
      "message": "Vous êtes sur le point de déplacer cette publication vers un canal privé. Seuls les membres de ce canal privé pourront la voir. Voulez-vous continuer ?"
    },
    "onlyAdminsCanPost": "Seuls les administrateurs de la communauté peuvent partager dans ce canal."
  },
  "reaction": {
    "noLikes": "Aucune mention J'aime",
    "andOthers": "et {count} autres"
  },
  "UIConfirmation": {
    "privateGroup": "Ce groupe est privé",
    "privateGroupMessage": "Vous devez être membre de ce groupe pour accéder à ses informations spécifiques. Veuillez demander l'accès en cliquant sur le bouton Rejoindre le groupe."
  },
  "notifications": {
    "noNotificationsYet": "Pas encore de rappel",
    "whenYouGetNotifications": "Quand vous recevez des rappels, ils s’affichent ici",
    "markAllAsRead": "Marquer tous les textes comme lus",
    "notifications": "Rappels",
    "all": "Tout",
    "unread": "Non lu",
    "checkNotifications": "Connectez-vous pour vérifier les rappels",
    "noNotifications": "Aucun rappel !",
    "redirectedFromOldSlug": {
      "title": "Vous avez été redirigé vers le lien de la communauté mis à jour",
      "content": "Cela a été fait pour améliorer la performance SEO de cette communauté. Veuillez actualiser vos favoris avec ce Nouveau URL."
    }
  },
  "joinGroupModal": {
    "wahoo": "Wahoo! 🎉, demande envoyée avec succès",
    "reviewRequestSoon": "Nos administrateurs de groupe examineront bientôt votre demande. Veuillez patienter, et nous vous informerons une fois votre adhésion acceptée.",
    "nonMemberMessage": "Vous devez faire partie de ce groupe pour aimer et commenter les publications.",
    "subscribeFor": "Abonnez-vous pour",
    "joinGroup": "REJOINDRE LE GROUPE",
    "membershipPending": "adhésion en attente",
    "viewMembershipAnswers": "afficher les réponses de adhésion",
    "requested": "Demandé",
    "dayFreeTrial": "Essai gratuit d'un jour",
    "notPartOfGroup": "Vous ne faites pas encore partie de ce groupe, vos demandes d'adhésion sont in avis. Une fois qu'un admin a accepté vos demandes, nous vous préviendrons",
    "pleaseAnswerMembershipQuestions": "Veuillez répondre aux questions d'adhésion pour confirmer ce groupe",
    "answerQuestions": "Répondre aux questions d’adhésion"
  },
  "userProfilePopover": {
    "active": "Actif",
    "longAgo": "il y a longtemps",
    "chatDisabled": "Cet utilisateur a désactivé son chat",
    "pointsToLevelUp": "points pour passer au niveau supérieur",
    "profile": "Profil",
    "deletedUser": "Utilisateur supprimé",
    "joined": "Membre",
    "contributions": "Contributions"
  },
  "courses": {
    "by": "Par",
    "free": "Gratuit",
    "unknownInstructor": "Instructeur Inconnu",
    "courseRestricted": "Ce chemin est privé",
    "courseDeleted": "Ce cours a été supprimé",
    "noMatchingCourseFound": "Aucun cours correspondant n’a été trouvé",
    "addCourse": "Ajouter un cours",
    "updateCourse": "Mettre à jour le cours",
    "access": "Tous les membres ont accès",
    "unableToAddCourse": "Oups ! Impossible d'ajouter le cours.",
    "pleaseTryAgainLater": "Veuillez réessayer plus tard",
    "paymentIntegrationMissing": "Oups ! L'intégration des paiements est manquante",
    "paymentIntegrationMissingMessage": "Veuillez intégrer les paiements dans le sous-compte pour activer les cours payés",
    "course": "Cours",
    "courseInThisGroup": "un cours existant dans ce groupe",
    "courseLinkCopied": "Lien du cours copié !",
    "buyNow": "ACHETER MAINTENANT",
    "locked": "Bloqué",
    "buyCourse": "ACHETER UN COURS",
    "open": "OUVERTE",
    "moveCard": "Déplacer une carte",
    "courseViewMessage": "Vous devez faire partie de ce groupe pour afficher les cours.",
    "deleteCourse": "Supprimer le cours",
    "deleteCourseConfirmation": "Voulez-vous vraiment supprimer ce cours ?",
    "courseAccessNotGranted": "Accès au cours non accordé",
    "courseAccessNotGrantedMessage": "Nous travaillons actuellement à vous donner accès au cours. Veuillez rafraîchir la page et réessayer dans quelques instants.",
    "autoRenewsAfter": "Se renouvelle automatiquement après",
    "oneTimePayment": "Paiement en une fois",
    "emptyCoursesMessage": "On dirait une ville fantôme. Rien à voir ici",
    "updatedSuccessfully": "cours mis à jour",
    "addedSuccessfully": "cours ajouté avec succès",
    "createCourse": "Créer un nouveau cours",
    "emptyCourseLibrary": "Votre bibliothèque de chemins est vide !",
    "createdOutsideGokollabMessage": "Cette communauté a été créée en dehors de Gokollab et rendue visible. Pour générer de nouveaux cours, veuillez vous connecter à la communauté depuis son canal Source.",
    "createCourseOnGokollabMessage": "Générer un Nouveau chemin activé Gokollab pour le Créer disponible à vos membres de communauté.",
    "or": "ou",
    "createNewOne": "créer un nouveau",
    "labels": {
      "selectCourse": "Sélectionner un cours",
      "courseVisibility": "visibilité du cours",
      "courseAccess": "Se connecter aux cours",
      "coursePrice": "Prix du cours",
      "subscriptionType": "Type d'abonnement",
      "billingPeriod": "Période de facturation",
      "testMode": "Mode Test",
      "turnOnTestPayments": "Activez les paiements de test via une carte de test",
      "currency": "Devise",
      "trialDays": "Jours d'essai",
      "recurring": "récurrent",
      "free": "gratuit",
      "oneTime": "Une Date",
      "refresh": "actualiser",
      "accessStartsAtDay": "accès commence à Jour",
      "maximumYouCanEnterIs365": "Le maximum que vous pouvez saisir est de 365",
      "allMembers": "chaque membre",
      "levelUnlock": "déverrouiller",
      "buyNow": "boutique",
      "timeUnlock": "Date de déverrouillé",
      "gamificationLevel": "niveau ludification",
      "privateChannel": "canal privé",
      "private": "Privé",
      "marketingChannel": "canal de marketing",
      "selectCurrency": "Sélectionner la devise"
    },
    "placeholders": {
      "enterPrice": "Entrez le prix",
      "enterTrialDays": "Entrez les jours d'essai",
      "selectCurrency": "Sélectionnez-en un",
      "selectBillingPeriod": "Sélectionnez-en un",
      "billingPeriod": "Sélectionner la période de facturation"
    },
    "validations": {
      "validPrice": "Veuillez saisir un prix valide",
      "required": "Veuillez sélectionner un cours",
      "validMembershipPrice": "Veuillez saisir un prix d'abonnement valide",
      "validTrialDays": "Veuillez saisir des jours d'essai valides.",
      "requiredSubscriptionType": "Veuillez sélectionner le type d'abonnement",
      "courseVisibility": "Veuillez fournir le texte que vous souhaitez traduire",
      "requiredGamificationLevel": "Veuillez fournir le texte que vous souhaitez traduire",
      "requiredPrivateChannel": "Veuillez fournir le canal privé",
      "validAccessStartDay": "Veuillez saisir une date de début valide"
    },
    "descriptions": {
      "buyNowDescription": "Ce cours est public lors de l'achat",
      "timeUnlockDescription": "membres après x jours",
      "levelUnlockDescription": "Les membres d'un certain niveau pourront déverrouiller",
      "allMembersDescription": "chaque membre a accès à ce cours",
      "privateChannelDescription": "membres d'un canal privé",
      "privateDescription": "Accès accordé par l'administrateur uniquement"
    },
    "helperText": {
      "levelBased": "niveau",
      "timeLimited": "Limites d'heure",
      "privateBased": "Privé",
      "free": "gratuit",
      "levelAvailableAt": "disponibles à 0{value}",
      "timeLimitedAfterJoining": "{value} {day}",
      "day": "Jour",
      "days": "dates",
      "purchaseToUnlockAccess": "acheter ce cours pour déverrouiller l'accès",
      "privateCourse": "Cours privé - Accès accordé par l'administrateur uniquement",
      "locked": "Ce cours est verrouillé",
      "unlockAtLevel": "Ce cours se déverrouillera à lisse {level}",
      "unlockAfterDays": "Ce cours se déverrouillera après {days} {dayText}",
      "privateChannelBased": "privé",
      "externalAccess": "Autre Groupe/Offre"
    },
    "manageAccess": {
      "manageCourses": "Gérer les cours",
      "revokeCourseAccess": "Gérez les cours",
      "grantCoursesAccess": "Accorder les cours",
      "removeAccess": "Retirer l'accès",
      "grantAccess": "Accorder l'accès",
      "grant": "Accorder",
      "clear": "Effacer",
      "selectAll": "Sélectionner tout",
      "revokeAccessConfirmTitle": "Supprimer l'accès au cours ?",
      "revokeAccessConfirmMessage": "Êtes-vous sûr de vouloir supprimer l'accès à « {courseName} » pour {userName} ?",
      "externalAccessTooltip": "Impossible de supprimer : l'utilisateur a accès depuis un autre groupe ou une autre offre",
      "cannotRevokeAutoAccess": "Impossible de supprimer : l'accès est automatiquement accordé en fonction des paramètres du cours (payant, niveau, durée ou gratuit).",
      "searchPlaceholder": "Recherchez des cours",
      "noCoursesFound": "Aucun cours trouvé",
      "noCoursesSelected": "Aucun cours n'a été sélectionné pour le moment",
      "noCoursesAvailable": "Aucun cours disponible à attribuer",
      "noSearchResults": "Aucun résultat de recherche",
      "failedToLoadCourses": "Impossible de charger les cours",
      "accessRevoked": "L'accès au cours a été supprimé avec succès",
      "failedToRevokeAccess": "Échec de la suppression de l'accès au cours",
      "accessGranted": "Accès au cours accordé avec succès",
      "multipleAccessGranted": "{count} cours accordés avec succès",
      "failedToGrantAccess": "L'accès au cours n'a pas été accordé"
    },
    "ariaLabels": {
      "courseCard": "Carte de cours",
      "courseCardActions": "Actions de la carte de cours",
      "editCourse": "Modifier le cours",
      "deleteCourse": "Supprimer le cours",
      "moveCard": "Déplacer la carte",
      "copyLink": "Copier le lien",
      "cardImage": "Image de la carte du cours"
    }
  },
  "about": {
    "notifications": {
      "errorUploadingFile": "Erreur lors du téléchargement du fichier"
    },
    "uploadLinkVideo": "Télécharger/lier une vidéo",
    "removeMedia": "Effacer le média {fileName}"
  },
  "leaderboard": {
    "level": "Niveau",
    "lastUpdated": "Dernière mise à jour",
    "members": "Membres",
    "percentOfMembers": "{percentage} % des membres",
    "rewards": "Récompenses",
    "allTime": "Tous le temps",
    "pointsToLevelUp": "points pour passer au niveau supérieur",
    "points": "Points",
    "leaderboard7d": "Classement (7 jours)",
    "leaderboard30d": "Classement (30 jours)",
    "leaderboardAlltime": "Classement (tout le temps)",
    "yourRank": "Votre classement",
    "noActivityToShow": "Aucune activité à afficher",
    "rewardsWillBeDisplayedHere": "Les récompenses seront affichées ici",
    "seeAllLeaderboards": "Voir tous les classements",
    "addRewards": "Ajouter des récompenses",
    "howPointsWork": "Vous gagnez des points quand d'autres membres aiment vos publications ou votre feedback. 1 J'aime = 1 point. Cela encourage les utilisateurs à générer du contenu de qualité et à interagir avec les autres membres de leur communauté.",
    "levels": "Niveaux",
    "levelsDescription": "Au fur et à mesure que vous gagnez des points, vous montez de niveau. Votre niveau est indiqué en bas à droite de votre avatar. Le nombre de points requis pour passer au niveau suivant est indiqué via la barre de progression sur la page du tableau de classement.",
    "pointsAndLevels": "points et calques"
  },
  "events": {
    "createEvent": "Créer un événement",
    "dragAndDrop": "Faites glisser et déposez un fichier SVG, PNG ou JPG (Max 800 x 400 px)",
    "editEvent": "Modifier l'événement",
    "addEvent": "Ajouter un événement",
    "paymentDetails": "Détails du paiement",
    "event": "Événement",
    "goBack": "Retour",
    "cancelEdit": "Annuler la modification",
    "cancelEvent": "Annuler l'événement",
    "next": "Suivant",
    "saveEvent": "Enregistrer l'événement",
    "editRecurringEvent": "Modifier l'événement récurrent",
    "thisEvent": "Cet événement",
    "thisAndFollowingEvents": "Cet événement et les suivants",
    "ok": "OK",
    "deleteRecurringEvent": "Supprimer l'événement récurrent",
    "allEvents": "Tous les événements",
    "adminsFreeForPaidEvents": " * les administrateurs peuvent inscrire pour des événements payants pour des raisons de",
    "deleteEvent": "Supprimer l'événement",
    "onceEventDeleted": "Une fois l'événement supprimé, il ne s'affichera plus dans votre calendrier.",
    "toRegister": "pour s'inscrire",
    "calendar": "Calendrier",
    "addToCalendar": "Ajouter au calendrier",
    "declineRegistration": "Refuser",
    "paymentFailedMessage": "Votre paiement a échoué en raison de circonstances imprévues ! Veuillez réessayer plus tard.",
    "upcoming": "À venir",
    "noMoreEvents": "Il n'y a plus d'événement à afficher",
    "joinGroupToRegister": "Vous devez faire partie de ce groupe pour vous inscrire à cet événement",
    "past": "Passé",
    "youHaveRegisteredForOneEvent": "Vous êtes inscrit à 1 événement. Nous vous enverrons un rappel un jour avant chaque événement.",
    "upcomingEvents": "Événements à venir",
    "noUpcomingEvents": "Aucun événement à venir",
    "pastEvents": "Événements passés",
    "noPastEvents": "Aucun événement passé",
    "noMatchingEventFound": "Aucun événement correspondant n’a été trouvé",
    "week": "Semaine",
    "month": "Mois",
    "today": "Aujourd'hui",
    "registrationConfirmed": "Confirmation d'inscription pour {event}.",
    "eventDeletedOrRestricted": "L’Événement est supprimé ou privé.",
    "eventDeleted": "L'événement a été supprimé",
    "eventRestricted": "Vous n'avez pas accès à cet événement",
    "validations": {
      "titleValidation": "Le titre est obligatoire",
      "colorValidation": "La couleur est obligatoire",
      "startTimeValidation": "L'heure de début est obligatoire",
      "endTimeValidation": "L'heure de fin est obligatoire",
      "endTimeAfterStartTime": "L’heure de fin doit être après l’heure de début !",
      "startTimeMustBeInFuture": "L'heure de début doit être dans le futur",
      "locationValidation": "L'emplacement est obligatoire",
      "locationValidationMobile": "L’emplacement est obligatoire",
      "locationUrlValidation": "Une URL d'emplacement valide est nécessaire",
      "descriptionValidation": "La description est obligatoire",
      "descriptionValidationMaxLength": "La description ne peut pas dépasser 300 caractères",
      "recaptchaError": "Échec de la vérification ! Veuillez réessayer",
      "repeatIntervalValidation": "La fréquence est obligatoire",
      "repeatIntervalValidator": "L'intervalle de répétition doit être un jour, une semaine, un mois ou une année",
      "repeatIntervalRequired": "L'intervalle de répétition est obligatoire",
      "repeatOccurrenceValidator": "La fréquence de répétition doit être supérieure à 0",
      "repeatOccurrenceRequired": "La fréquence de répétition est obligatoire",
      "invalidDateFormat": "Format de date non valide",
      "endDateMustBeAfterStartDate": "La date de fin doit être après la date de début de l'événement",
      "recurringEndDateValidation": "La date de fin récurrente est obligatoire",
      "repeatsOnValidation": "Veuillez sélectionner au moins un jour",
      "invalidDaySelection": "Sélection de jour non valide",
      "endOptionRequired": "L'option de fin est obligatoire",
      "levelValidation": "Veuillez sélectionner un niveau",
      "courseValidation": "Veuillez sélectionner un cours",
      "channelValidation": "Veuillez sélectionner un canal",
      "eventPriceValidation": "Le prix est obligatoire et doit être supérieur à {min}"
    },
    "placeholders": {
      "selectStartTime": "Sélectionner l'heure de début",
      "selectEndTime": "Sélectionner l'heure de fin",
      "selectLocation": "Sélectionner un emplacement",
      "locationUrl": "Lien/Adresse",
      "description": "Description",
      "selectRecurringEndDate": "Sélectionner une date de fin récurrente",
      "selectDate": "Sélectionner une date",
      "event": "Événement",
      "selectColor": "Sélectionnez une couleur",
      "selectAttendees": "Sélectionnez les participants",
      "selectPrivateChannel": "Sélectionner un canal privé",
      "selectCourse": "Sélectionner un cours",
      "selectLevels": "Sélectionner des niveaux",
      "selectCalendar": "Sélectionner un calendrier"
    },
    "labels": {
      "startTime": "Heure de début",
      "endTime": "Heure de fin",
      "others": "Autres",
      "oneTimePriceForEventRegistration": "prix unique pour l'inscription à un événement.",
      "totalAmount": "Montant total",
      "cardAuthorizationText": "En fournissant les informations de votre carte, vous autorisez {locationName} à débiter votre carte pour les paiements futurs conformément à ses conditions.",
      "secureAndSafePayments": "Paiements 100 % sécurisés",
      "day": "Jour",
      "week": "Semaine",
      "month": "Mois",
      "year": "Année",
      "recurringEvent": "L’événement sera-t-il récurrent ?",
      "repeatsEvery": "Se répète chaque",
      "repeatsOn": "Se répète le",
      "end": "Fin",
      "ends": "fin",
      "neverEnds": "Ne finit jamais",
      "orange": "Orange",
      "red": "Rouge",
      "blue": "Bleu",
      "green": "Vert",
      "violet": "Violet",
      "purple": "Violet",
      "yellow": "Jaune",
      "title": "Titre",
      "color": "Couleur",
      "allMembers": "Tous les membres",
      "membersAtALevel": "Membres à un niveau",
      "membersOfACourse": "Membres d'un cours",
      "membersOfAPrivateChannel": "Membres d'un canal privé",
      "whoCanAttendTheEvent": "Qui peut participer à l'événement ?",
      "channel": "Canal",
      "course": "Cours",
      "level": "Niveau",
      "remindAttendeesByEmail": "Rappeler aux participants via adresse e-mail 1 jour avant",
      "hideLocationFromNonAttendees": "Masquer l’emplacement aux non-participants.",
      "addChargesToTheEvent": "facturation de l'événement",
      "noPaymentRequired": "Aucun paiement obligatoire",
      "location": "emplacement",
      "link": "lien",
      "description": "Description",
      "timezone": "Fuseau horaire",
      "eventType": "saisir d'événement",
      "eventTypeChangeWarning": "dynamique vers le saisir d'événement ou la tarification s'appliquera à chaque événement in la série.",
      "never": "Jamais",
      "on": "se",
      "after": "après",
      "occurrences": "événements",
      "selectEventEnd": "Sélectionner quand l'événement terminera.",
      "turnOnTestPayments": "Les paiements de Test via une carte de Test",
      "pay": "payer",
      "hideAttendees": "masquer les participants des membres du groupe",
      "guests": "{count} invités",
      "guestList": "liste des Invité",
      "noAttendees": "Aucun participant n'a encore",
      "viewAttendees": "afficher les participants",
      "exportAttendees": "exporter les participants"
    },
    "notifications": {
      "eventCreated": "Créé avec succès !",
      "eventUpdated": "Événement mis à jour !",
      "eventCreationFailed": "La création de Événement a échoué !",
      "eventUpdateFailed": "La mise à jour de Événement a échoué !",
      "eventDeleted": "Événement supprimé avec succès !",
      "eventDeletionFailed": "La suppression de l'événement a échoué !",
      "paymentFailed": "Le paiement a échoué !",
      "registrationSuccessful": "Inscription réussie !",
      "registrationFailed": "L’inscription a échoué !",
      "addToCalendarFailed": "Impossible d'ajouter l'événement au calendrier !",
      "locationDetailsCopied": "Les informations sur l’emplacement ont été copiées dans le presse-papiers !",
      "registrationDeclined": "Inscription refusée avec succès !",
      "registrationDeclinedFailed": "Le refus de l'inscription a échoué !",
      "fetchAttendeesFailed": "échec de charger les participants",
      "emailCopied": "E-mail copié dans le presse-papiers",
      "exportAttendeesFailed": "Échec de l'exportation des participants"
    },
    "selectCalendar": "Sélectionner un calendrier",
    "eventImage": "Image de l'événement",
    "errorLoadingEvent": "Échec du chargement de l'événement"
  },
  "login": {
    "invite": "vous a invité(e) à rejoindre"
  },
  "contentReports": {
    "contentDeleted": "Le contenu a été supprimé !",
    "noActionTaken": "Aucune mesure n’a été prise sur le contenu signalé !",
    "reportedContentNotFound": "Contenu signalé non trouvé, peut-être déjà traité.",
    "reported": "Signalé",
    "viewAllReportedContentHere": "Vous pouvez afficher tout le contenu signalé ici",
    "takeActionOnReportedContent": "Prendre des mesures concernant le contenu signalé",
    "andOthers": "et {count} autres",
    "reportedThisPost": "a signalé cette publication",
    "keep": "CONSERVER",
    "remove": "SUPPRIMER",
    "deleteContent": "Supprimer le contenu",
    "deleteConfirmation": "Êtes-vous sûr de vouloir supprimer ce contenu ?",
    "noMemberReportedContent": "Aucun contenu signalé par les membres",
    "whenMembersReportPostsOrComments": "Quand les membres signalent des publications ou donnent un feedback, ils apparaissent ici pour que vous puissiez les consulter. Vous pouvez les conserver ou les supprimer, ainsi que suspendre, supprimer ou bloquer les membres qui les ont publiés.",
    "reportedThisComment": "Vous avez signalé ce commentaire"
  },
  "contentUnavailable": {
    "thisContentIsntAvailable": "Ce contenu n'est pas disponible pour le moment",
    "whenThisHappens": "Lorsque cela se produit, c'est généralement parce que le propriétaire n'a partagé le contenu qu'avec un petit groupe de personnes, qu'il a modifié les personnes qui peuvent le voir ou qu'il a été supprimé."
  },
  "search": {
    "noResultsFor": "0 résultat pour « {query} » dans la communauté",
    "noResultsFound": "Aucun résultat trouvé"
  },
  "noCommunities": {
    "noCommunitiesFound": "Aucune communauté trouvée",
    "startCreatingYourOwnCommunities": "Commencez à créer vos propres communautés et interagissez avec votre public !",
    "noCommunitiesFoundGokollab": {
      "notJoinedA": "Pas encore membre d'une",
      "communities": "communauté",
      "yet": " "
    },
    "noCommunitiesFoundGokollabDescription": "Découvrez des espaces où partager vos idées, trouver et offrir du soutien, mais aussi évoluer ensemble."
  },
  "noCourses": {
    "noCoursesFoundGokollab": {
      "notEnrolledInA": "Pas encore inscrit(e) à un",
      "course": "cours",
      "yet": " "
    },
    "noCoursesFoundGokollabDescription": "Découvrez des cours à fort impact conçus pour faciliter l'apprentissage, le développement de compétences et la réussite."
  },
  "notFound": {
    "ohNo": "oh non...",
    "weHaveHadAnError": "Il y a eu une erreur",
    "error404": "Erreur 404",
    "sorryPleaseCheckBack": "Désolés... veuillez revenir dans un instant."
  },
  "time": {
    "justNow": "Tout à maintenant",
    "timeAgo": "il y a {value}{unit}",
    "timeAgoFull": "il y a {value} {unit}",
    "units": {
      "year": "a",
      "years": "années",
      "month": "m",
      "months": "mois",
      "week": "sem",
      "weeks": "semaines",
      "day": "j",
      "days": "jours",
      "hour": "h",
      "hours": "heures",
      "minute": "m",
      "minutes": "minutes",
      "second": "s",
      "seconds": "seconde",
      "monthly": "Mensuellement",
      "weekly": "Hebdomadaire",
      "annually": "Annuellement"
    },
    "dayAbbreviations": {
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mer",
      "thu": "Jeu",
      "fri": "Ven",
      "sat": "Sam",
      "sun": "Dim"
    }
  },
  "emojiPicker": {
    "notfound": "Aucun e-mail trouvé",
    "recent": "fréquence utilisée",
    "smileys": "E-mails et e-mail",
    "people": "Personnel et corps",
    "nature": "obligatoires et",
    "foods": "Nommez-vous",
    "activity": "activité",
    "places": "Déplacer et les lieux",
    "objects": "objets",
    "symbols": "symboles",
    "flags": "drapeaux",
    "custom": "Personnalisée"
  },
  "topNavBarHeaderText": {
    "discussion": "Discussion",
    "learning": "apprentissage",
    "people": "personnes"
  },
  "globalUserProfile": {
    "ownedBy": "Propriétaire : {name}",
    "memberships": "Abonnements",
    "membershipsInCommon": "Abonnements ({count} en commun)",
    "membersCount": "{count} membres",
    "contributions": "{count} contributions à {group}",
    "contributionsFor": "Contributions pour",
    "justPosts": "Juste des publications",
    "postAndComments": "Publication et commentaires",
    "followSuccess": "Vous avez commencé à Suivant",
    "unfollowSuccess": "Vous ne suivez plus cet élément."
  },
  "profile": {
    "active": "Actif",
    "ago": "Il y a",
    "bio": "Biographie"
  },
  "golive": {
    "golive": "Passer en direct",
    "selectVideoSourceToStart": "Sélectionnez une source vidéo pour commencer le streaming.",
    "chooseHowToGoLive": "Choisissez comment vous souhaitez passer en direct",
    "flipCamera": "Retourner la caméra",
    "participants": "Participants",
    "chats": "Chats",
    "react": "React",
    "raise": "Rehausser",
    "shareScreen": "Partager",
    "letsCheckYourCamAndMic": "Vérifions votre caméra et votre micro",
    "hostedBy": "Animé par",
    "join": "Rejoindre",
    "needCameraPermission": "Besoin de la permission de la caméra",
    "needMicrophonePermission": "Permission d'accès au microphone requise",
    "needSpeakerPermission": "Permission de prise de parole requise",
    "createLiveVideo": "Créer une vidéo en direct",
    "host": "Hôte",
    "chooseWhereToPost": "Sélectionner l'endroit où poster",
    "whenAreYouGoingLive": "Quand allez-vous passer en direct ?",
    "postingIn": "publication dans",
    "live": "En direct",
    "postDetails": "Détails de la publication",
    "streamingSoftware": "Logiciel de streaming",
    "streamingSoftwareDescription": "Vous pouvez utiliser des applications de streaming comme Zoom, OBS ou StreamYard pour diffuser en direct. Il suffit de copier l'URL et la clé de streaming fournies dans les paramètres de votre logiciel de streaming. Une fois la configuration terminée, lancez votre flux dans le logiciel et il sera diffusé en direct sur la plateforme de votre choix automatiquement.",
    "streamKey": "Clé de diffusion",
    "streamKeyDescription": "Ceci peut être réutilisé chaque fois que vous passez en direct. Vous ne pouvez diffuser qu'une seule vidéo en direct à la fois avec votre jeton de flux épinglé.",
    "serverUrl": "URL du serveur",
    "serverUrlDescription": "Dans votre logiciel de streaming, cette adresse peut être appelée URL ou Adresse.",
    "selectVideoSource": "Sélectionnez la source vidéo",
    "copyPasteStreamKey": "Copiez-collez la clé de diffusion dans votre logiciel de streaming.",
    "copyPasteServerUrl": "Copiez-collez l'URL de serveur dans votre logiciel de streaming.",
    "addPostDetails": "Ajouter les détails de la publication",
    "enterTitle": "Saisissez un titre",
    "notifyMembers": "Notifier les membres que vous allez passer en direct (envoie uniquement des notifications in-app et push)",
    "notifyMembersMobile": "Notifiez les membres que vous allez passer en direct",
    "meetingRoom": "Salle de réunion",
    "meetingRoomDescription": "Utilisez la fonctionnalité Salles de réunion pour organiser des sessions en direct au cours desquelles tous les participants peuvent allumer leur webcam, activer le son et interagir en temps réel. Cela crée une expérience de salle virtuelle similaire à Zoom ou Google Meet, permettant à chacun de se voir et de se parler en face à face.",
    "cameraControls": "Commandes de caméra",
    "cameraControlsTooltip": "Configurez votre caméra et vos paramètres audio avant de passer en direct. Assurez-vous que votre caméra et votre microphone sont correctement connectés et qu'ils disposent des autorisations nécessaires.",
    "selectMediaSource": "Sélectionnez une source de média",
    "startScreenShare": "Démarrer le partage d'écran",
    "stopScreenShare": "Arrêter le partage d'écran",
    "wasLive": "était en direct",
    "isLive": "est en direct",
    "goingLive": "va passer en direct",
    "tapToAddDescription": "Touchez pour ajouter une description...",
    "selectChannel": "Sélectionner un canal",
    "saveAsPost": "Conserver le streaming en tant que publication",
    "selectVideoSourceTooltip": "Vous avez le choix entre un logiciel de streaming ou une webcam lorsque vous êtes en direct :\n\n1. Logiciel de streaming\n - Nous vous fournirons une clé de diffusion et une URL de diffusion.\n   • Vous devez les configurer dans Zoom, OBS ou tout autre logiciel tiers prenant en charge la diffusion en direct.\n\n2. Webcam\n - Utilisez directement votre caméra et votre microphone.\n   • Les participants peuvent suivre la diffusion en direct et interagir via le chat en direct.\n   • En tant qu'hôte, vous pouvez contrôler et révoquer l'accès à la caméra ou au microphone à tout moment.",
    "pleaseSelectCameraMicrophoneSpeaker": "Veuillez sélectionner la caméra, le microphone et le haut-parleur.",
    "pleaseStartStreamBeforeGoingLive": "Veuillez démarrer le flux avant de passer en direct",
    "watching": "En cours de visionnage",
    "processingRecording": "Chargement de l'enregistrement",
    "streamEndedRecordingWillBeAvailableSoon": "Stream terminé. L’enregistrement est en cours de traitement et sera disponible sous peu.",
    "joinStream": "Rejoindre le stream",
    "recordingInProgress": "Enregistrement en cours",
    "recordingNotAvailable": "L'enregistrement n'est pas disponible",
    "leaveSession": "Quitter la session",
    "endSession": "Mettre fin à la session",
    "rec": "REC",
    "selectCamera": "Sélectionner la caméra",
    "noCamerasFound": "Aucune caméra trouvée",
    "cameraPermissionNeeded": "Autorisation d'accès à la caméra requise",
    "leave": "Quitter",
    "chooseMicCam": "Sélectionnez le micro/la caméra",
    "selectMicrophone": "Sélectionner le microphone",
    "selectSpeaker": "Sélectionnez le haut-parleur",
    "noMicrophonesFound": "Aucun microphone trouvé.",
    "noSpeakersFound": "Aucun haut-parleur trouvé",
    "microphonePermissionNeeded": "Permission de microphone requise",
    "speakerPermissionNeeded": "Permission de haut-parleur requise",
    "noParticipantOpenCamOrMic": "Cette réunion n'a pas été enregistrée, car aucun participant n'a activé son micro ou sa caméra. Les enregistrements ne sont créés que quand au moins un participant interagit."
  }
}
